import { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Heading,
  useToast,
  Spinner,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Avatar,
  AvatarGroup,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Select as SelectChakra,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  Popover,
  PopoverTrigger,
} from "@chakra-ui/react";
import axios from "axios";
import { Tooltip as TooltipChakra } from "@chakra-ui/react";
import Navbar from "../../../Components/Navbar";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { useDispatch } from "react-redux";
import { getUsers } from "../../../Redux/app/action";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../../Components/Sidebar";

const BASE_URL = "https://develop-project-360.onrender.com";

export const getAllProjects = () => axios.get(`${BASE_URL}/getAllProjects`);
export const getStagesByProject = (projectId) =>
  axios.get(`${BASE_URL}/project/${projectId}`);

const EmpProjectDashboard = () => {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [stages, setStages] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();
  // const isMobile = useBreakpointValue({ base: true, md: false });

  ///////////////////////////////////////////////////
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);

  const adminIdGlobal = useSelector((store) => store.authentication.users.id);
  const [selectedStage, setSelectedStage] = useState(null);

  ////////////////////////////////////////

  useEffect(() => {
    getAllProjects()
      .then((res) => {
        const allProjects = res.data.data || [];

        const filteredProjects = allProjects.filter((project) => {
          const adminIdStr = adminIdGlobal.toString();
          return (
            (project.members || []).some(
              (member) => member._id.toString() === adminIdStr
            ) ||
            (project.team_leads || []).some(
              (lead) => lead._id.toString() === adminIdStr
            ) ||
            (project.assigned_by &&
              project.assigned_by.toString() === adminIdStr)
          );
        });

        setProjects(filteredProjects);
        if (filteredProjects.length > 0) {
          setSelectedProject(filteredProjects[0]);
        }
      })
      .catch(() =>
        toast({ title: "Failed to load projects", status: "error" })
      );
  }, [toast, adminIdGlobal]);

  useEffect(() => {
    if (selectedProject?._id) {
      setLoading(true);
      getStagesByProject(selectedProject._id)
        .then((res) => {
          setStages(res.data.data || []);
        })
        .catch(() => toast({ title: "Failed to load stages", status: "error" }))
        .finally(() => setLoading(false));
    }
  }, [selectedProject, toast]);

  const handleProjectChange = (e) => {
    const projectId = e.target.value;
    const project = projects.find((p) => p._id === projectId);
    setSelectedProject(project);
  };

  const [hoveredIdEmployee, setHoveredIdEmployee] = useState(null);

  const handleHoverEmployee = (id) => {
    setHoveredIdEmployee(id);
  };

  const handleMouseLeaveEmployee = () => {
    setHoveredIdEmployee(null);
  };

  const handleStatusChange = async (stageId, newStatus, stageName) => {
    try {
      const response = await axios.put(`${BASE_URL}/stage/${stageId}/status`, {
        status: newStatus,
      });

      // Update the local stages state
      setStages((prevStages) =>
        prevStages.map((stage) =>
          stage._id === stageId ? { ...stage, status: newStatus } : stage
        )
      );

      toast({
        title: "Status updated",
        description: `${stageName} status changed to ${newStatus}`,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
        variant: "subtle",
      });
    } catch (error) {
      console.error("Error updating status:", error);
      toast({
        title: "Failed to update",
        description: "Something went wrong while changing the status.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex>
      <Sidebar />
      <Box
        pl={{ base: "2", md: "10" }}
        pt={{ base: "10", md: "10" }}
        w={{ base: "100%", md: "80%" }}
      >
        <Navbar />
        <br />
        <br />
        <Box>
          <Flex justifyContent={"space-between"}>
            <Breadcrumb
              spacing="8px"
              mb={6}
              separator={<ChevronRightIcon color="gray.500" />}
            >
              <BreadcrumbItem>
                <BreadcrumbLink href="/">Dashboard</BreadcrumbLink>
              </BreadcrumbItem>

              <BreadcrumbItem>
                <BreadcrumbLink href="#">Project Dashboard</BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
          </Flex>

          {/* Kanban Board Section */}
          <Flex
            direction={{ base: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ base: "flex-start", md: "center" }}
            gap={4}
            mb={4}
            mt={4}
          >
            {projects.length > 0 && (
              <SelectChakra
                placeholder="Select Project"
                onChange={handleProjectChange}
                value={selectedProject?._id || ""}
                width={{ base: "100%", md: "450px" }}
                maxH={10}
                overflowY={20}
              >
                {projects
                  .filter((project) => {
                    const adminIdStr = adminIdGlobal.toString();
                    return (
                      (project.members || []).some(
                        (member) => member._id.toString() === adminIdStr
                      ) ||
                      (project.team_leads || []).some(
                        (lead) => lead._id.toString() === adminIdStr
                      ) ||
                      (project.assigned_by &&
                        project.assigned_by.toString() === adminIdStr)
                    );
                  })
                  .map((project) => (
                    <option key={project._id} value={project._id}>
                      {project.name}
                    </option>
                  ))}
              </SelectChakra>
            )}

            <Heading
              size="md"
              textAlign={{ base: "left", md: "right" }}
              width="100%"
            >
              {selectedProject?.priority || "No Priority"} -{" "}
              {selectedProject?.status || "No Status"}
            </Heading>
          </Flex>

          {loading ? (
            <Spinner size="lg" />
          ) : (
            <Box overflowX="auto">
              <Table variant="simple" colorScheme="teal" boxShadow={"md"}>
                <Thead>
                  <Tr boxShadow={"md"}>
                    <Th style={{ textAlign: "center" }} boxShadow={"md"}>
                      Phases
                    </Th>
                    <Th style={{ textAlign: "center" }} boxShadow={"md"}>
                      Description
                    </Th>
                    <Th style={{ textAlign: "center" }} boxShadow={"md"}>
                      Assigned To
                    </Th>
                    <Th style={{ textAlign: "center" }} boxShadow={"md"}>
                      Tasks Count
                    </Th>
                    <Th style={{ textAlign: "center" }} boxShadow={"md"}>
                      Created At
                    </Th>
                    <Th style={{ textAlign: "center" }} boxShadow={"md"}>
                      Status
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {stages.map((stage, index) => (
                    <Tr key={stage._id}>
                      <Td style={{ textAlign: "center" }}>
                        <Button size={"xs"} fontWeight={"bold"}>
                          {stage.name}
                        </Button>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Button size={"xs"} fontWeight={"bold"}>
                          {stage.description || "N/A"}
                        </Button>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Flex justifyContent="center" alignItems="center">
                          <TooltipChakra
                            label={`Assigned To: ${selectedProject.members
                              .map((m) => m.sudo_name)
                              .join(", ")}`}
                            isOpen={hoveredIdEmployee === stage._id}
                            placement="bottom"
                            color="green.500"
                          >
                            <Flex
                              onMouseEnter={() =>
                                handleHoverEmployee(stage._id)
                              }
                              onMouseLeave={handleMouseLeaveEmployee}
                            >
                              <AvatarGroup size="xs" max={4}>
                                {selectedProject.members.map((member, idx) => (
                                  <Avatar
                                    key={idx}
                                    name={member.sudo_name}
                                    src={`https://develop-project-360.onrender.com/${member.path}`}
                                  />
                                ))}
                              </AvatarGroup>
                              <Button
                                size="xs"
                                fontWeight="bold"
                                onMouseEnter={() =>
                                  handleHoverEmployee(stage._id)
                                }
                                onMouseLeave={handleMouseLeaveEmployee}
                              >
                                {selectedProject.members[0]?.sudo_name || "N/A"}
                              </Button>
                              {selectedProject.members.length > 1 && (
                                <Button
                                  size="xs"
                                  rounded="full"
                                  fontWeight="bold"
                                  bg="gray.300"
                                  color="red"
                                  fontSize={10}
                                  ml={2}
                                  onMouseEnter={() =>
                                    handleHoverEmployee(stage._id)
                                  }
                                  onMouseLeave={handleMouseLeaveEmployee}
                                >
                                  +{selectedProject.members.length - 1}
                                </Button>
                              )}
                            </Flex>
                          </TooltipChakra>
                        </Flex>
                      </Td>

                      <Td style={{ textAlign: "center" }}>
                        <Button
                          size="xs"
                          fontWeight="bold"
                          onClick={() =>
                            navigate("/employee/viewtask", {
                              state: {
                                selectedProject,
                                stage: selectedStage,
                              },
                            })
                          }
                        >
                          {stage.tasks?.length || 0}
                        </Button>
                      </Td>

                      <Td style={{ textAlign: "center" }}>
                        <Button size={"xs"} fontWeight={"bold"}>
                          {new Date(stage.createdAt).toLocaleDateString()}
                        </Button>
                      </Td>

                      <Td style={{ textAlign: "center" }}>
                        <Popover placement="bottom">
                          <PopoverTrigger>
                            <Button
                              size={"xs"}
                              fontWeight={"bold"}
                              color={
                                stage.status === "Cancelled"
                                  ? "red"
                                  : stage.status === "Completed"
                                  ? "green"
                                  : stage.status === "On Hold"
                                  ? "orange"
                                  : "blue"
                              }
                            >
                              {stage.status}
                            </Button>
                          </PopoverTrigger>
                          <PopoverContent width="auto">
                            <PopoverArrow />
                            <PopoverCloseButton />
                            <PopoverBody p={5}>
                              {[
                                "Pending",
                                "Completed",
                                "On Hold",
                                "Cancelled",
                              ].map((statusOption) => (
                                <Button
                                  key={statusOption}
                                  size="xs"
                                  colorScheme={
                                    statusOption === "Cancelled"
                                      ? "red"
                                      : statusOption === "Completed"
                                      ? "green"
                                      : statusOption === "On Hold"
                                      ? "orange"
                                      : "blue"
                                  }
                                  m={1}
                                  onClick={() =>
                                    handleStatusChange(
                                      stage._id,
                                      statusOption,
                                      stage.name
                                    )
                                  }
                                >
                                  {statusOption}
                                </Button>
                              ))}
                            </PopoverBody>
                          </PopoverContent>
                        </Popover>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Box>
          )}
        </Box>
      </Box>
    </Flex>
  );
};

export default EmpProjectDashboard;
